import { useEffect} from "react";
import {useTranslation} from "react-i18next";

const Point = () => {
    const { t } = useTranslation();

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    return (
        <div className="minHeight">
            <div className="main-container">
                <div className="px-60 mt-20 mb-10" style={{userSelect:"text"}}>
                    <div className="fs_h1 pb-7">
                        {t("page.FOOTER_point-title")}
                    </div>
                    <div className="fs_16 text-left w-full h-auto text-black font-bold text-lg whitespace-pre-wrap pt-3">
                        {t("page.FOOTER_point-head1")}
                        <span style={{fontSize:"10px"}}>●</span><span>{t("page.FOOTER_point-head2")}</span>
                        <span style={{fontSize:"10px"}}>●</span>{t("page.FOOTER_point-head3")}
                        <span style={{fontSize:"10px"}}>●</span>{t("page.FOOTER_point-head4")}
                        <span style={{fontSize:"10px"}}>●</span>{t("page.FOOTER_point-head5")} <button onClick={() => window.open("https://docs.google.com/forms/d/e/1FAIpQLSdHCk2wceGjtG8DVIBxyfz0a5W70X8gRBZJNxz_WibCgt8k8A/viewform")} style={{textDecoration: "underline",color: "#13c1f1"}}> {t("page.FOOTER_point-link")}</button>{t("page.FOOTER_point-after")}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Point;